export default __webpack_public_path__ + "334636ec5208b8fd40d927c88cb84de0.png";